<template>
  <div class="fullpage">
    <div v-if='type===TYPE_COUPON || type===TYPE_COUPONED'>
      <div>
        <coupon-list
          :show="showCoupon"
          :coupon-config="couponConfig"
          :type="type"
          @onHide="handleHide"
          :coupon-list="couponList"
          :errmsg="couponErrormsg"
          :loading="loading"
          @onHideLoad="handleLoading"
        ></coupon-list>
      </div>
    </div>
    <div v-if='type===TYPE_IMAGE'>
      <img-content
        :img-config="imgConfig"
        @onHide="handleHide"
        :loading="loading"
        @onHideLoad="handleLoading"
      ></img-content>
    </div>
    <div v-if='type===TYPE_CODE'>
      <promo-code
        :config="promoCodeConfig"
        @onHide="handleHide"
        :loading="loading"
        @onHideLoad="handleLoading">
      </promo-code>
    </div>
    <div v-if='type===TYPE_LOGIN && loginShow'>
      <no-login
        :config="loginConfig"
        :loading="loading"
        @onHide="handleHide"
        @onLogin="handleLogin"
        @onHideLoad="handleLoading"
      ></no-login>
    </div>
    <loading-mask v-show="loading || !loginShow"></loading-mask>
  </div>
</template>
<script>
  import CouponList from './couponList'
  import PopContainer from '@/components/pop-container'
  import ImgContent from './imgContent'
  import NoLogin from './noLogin'
  import PromoCode from './promo-code'
  import LoadingMask from '@/components/loading/loading-mask'
  import * as Api from '@/page/banner/store/api'
  import i18n from '@/common/js/i18n'
  import trackEvent from '@/common/js/track'
  import PerformanceTool from '@didi/soda-fe-performance-tool'

  const TYPE_COUPON = 1 // 弹窗发券
  const TYPE_COUPONED = 2 // 弹窗展示已有券
  const TYPE_IMAGE = 3 // 弹窗展示图文
  const TYPE_CODE = 4 // 兑换码弹窗
  const TYPE_LOGIN = 5 // 引导登录弹窗
  const IOS_DATA_TYPE = 9 // ios默认dataType
  
  const couponError = {
    '50003': i18n.gettext('网络异常，请稍后再试'),
    '10003': i18n.gettext('很遗憾，未能领取成功'),
    '10005': i18n.gettext('已参与过同类型活动</br>快去下单吧')
  }
  export default {
    name: 'BannerPop',
    components: {
      CouponList,
      PopContainer,
      ImgContent,
      NoLogin,
      LoadingMask,
      PromoCode
    },
    data () {
      return {
        loading: true, // loading加载
        type: '',
        baseConfig: { // 基础触发时机(1首页, 2订单支付后)、活动id
          tigger: '',
          activityId: ''
        },
        couponConfig: { // 券配置信息
          skinUrl: '',
          color: '',
          btnText: '',
          btnUrl: ''
        },
        imgConfig: { // 图片配置信息
          imgUrl: '',
          redirect: ''
        },
        textConfig: { // 文本配置信息
          textDescription: '',
          redirect: ''
        },
        promoCodeConfig: { // 兑换码
          code: '',
          btnUrl: '',
          imgUrl: ''
        },
        loginConfig: { // 未登录弹窗
          imgUrl: ''
        },
        couponList: [],
        showCoupon: false, // 登录显示券列表
        couponErrormsg: '', // 券接口异常
        popupUrl: '', // 登录后请求popdialog 后获取到的值
        TYPE_COUPON: TYPE_COUPON,
        TYPE_COUPONED: TYPE_COUPONED,
        TYPE_IMAGE: TYPE_IMAGE,
        TYPE_CODE: TYPE_CODE,
        TYPE_LOGIN: TYPE_LOGIN,
        apiRequestTime: 0, // 接口api时长-埋点
        loginShow: true // 未登录弹窗->登录回调->登录框闪动
      }
    },
    created () {
      // 页面加载时间loading时限
      setTimeout(() => {
        if (this.loading) {
          this.handleHide()
        }
      }, 10000)
    },
    mounted () {
      this.initQuery()
    },
    methods: {
      initQuery (q) {
        const query = q || this.$route.query
        this.type = +query.type
        let tigger = this.getDecodeURI('trigger', query)
        let activityId = this.getDecodeURI('activityId', query)
        let timezone = this.getDecodeURI('timezone', query)
        this.baseConfig = {
          tigger: tigger,
          activityId: activityId && activityId.split(',')[0],
          timezone: timezone
        }
        this.couponConfig = {
          skinUrl: this.getDecodeURI('skinUrl', query),
          color: this.getDecodeURI('color', query),
          btnText: this.getDecodeURI('btnText', query),
          btnUrl: this.getDecodeURI('btnUrl', query),
          ...this.baseConfig
        }
        this.imgConfig = {
          imgUrl: this.getDecodeURI('imgUrl', query),
          redirect: this.getDecodeURI('redirect', query),
          ...this.baseConfig
        }
        this.promoCodeConfig = {
          code: this.getDecodeURI('promoCode', query),
          btnUrl: this.getDecodeURI('btnUrl', query),
          imgUrl: this.getDecodeURI('imgUrl', query),
          ...this.baseConfig
        }
        this.textConfig = {
          text: this.getDecodeURI('text', query),
          redirect: this.getDecodeURI('redirect', query),
          ...this.baseConfig
        }
        this.loginConfig = {
          imgUrl: this.getDecodeURI('imgUrl', query),
          ...this.baseConfig
        }
        if (this.type === TYPE_COUPON || this.type === TYPE_COUPONED) {
          this.initCoupon()
        } else {
          this.trackMounted({
            trigger_timing: this.baseConfig.tigger,
            window_type: 2,
            activity_id: this.baseConfig.activityId
          })
        }
      },
      async initCoupon () {
        this.userInfo = await this.SodaBridgeData('getUserInfo')
        // 已登录用户，展示券列表弹窗
        if (this.userInfo && this.userInfo.token) {
          this.showCouponList()
        } else {
          this.handleHide()
        }
      },
      async showCouponList () {
        // 显示券弹框
        let requestStart = new Date().getTime()
        try {
          // 获取客户端公参，后端需要用定位信息反解券的货币格式、时间
          let globalParamsData = await this.SodaBridge('getGlobalParams', 'badcase')
          const globalParams = globalParamsData.data
          let couponInfo = await Api.getFallCouponList({
            ...globalParams,
            token: this.userInfo.token || '',
            type: this.type,
            timezone: this.baseConfig.timezone
          })
          let coupon = couponInfo.data.data
          // 领券成功后展示券，券为空时显示错误信息；领券失败显示错误信息
          if (couponInfo.data.errno === 0) {
            this.couponList = coupon.couponDetailList
            if (this.couponList.length === 0) {
              this.couponErrormsg = couponError['10003']
            }
          } else {
            this.couponErrormsg = couponError[couponInfo.data.errno] || couponInfo.data.errmsg
          }
          this.showCoupon = true
          this.trackMounted({
            trigger_timing: this.baseConfig.tigger,
            window_type: 1,
            redbag_list: this.couponList,
            activity_id: this.baseConfig.activityId
          })
          this.trackApi(requestStart, couponInfo.data)
        } catch (e) {
          this.trackApi(requestStart, e)
          // 出错时，提示系统繁忙，关闭弹框
          this.loading = false
          let errorToast = this.$createToast({
            txt: this.gettext('网络繁忙，请稍后再试'),
            time: 2000,
            mask: false,
            type: 'error'
          })
          errorToast.show()
          window.setTimeout(() => this.handleHide(), 2000)
          console.warn(`showCouponList`, e)
        }
      },
      async handleHide () {
        this.SodaBridge('closePage')
      },
      handleLogin () {
        this.loginMethod((info) => {
          // 未登录时，跳转登录，因本次在ios上天降webview与平常打开webview不一样，所以新开登录接口
          if (info && info.token) {
            this.loginShow = false
            this.userInfo = info
            trackEvent({
              eventId: 'sailing_c_x_login_window_close_ck',
              eventLabel: '客户命中活动，关闭登录页面',
              attrs: {
                activity_id: this.baseConfig.activityId,
                uid: this.userInfo.uid
              }
            })
            this.dispatchPopDialog()
          } else {
            this.handleHide()
          }
        })
      },
      // 吊起登录方式
      async loginMethod (callback) {
        let canCustomerLogin = await this.SodaBridge('canIUse', 'customer.requestLogin')
        let canLogin = await this.SodaBridge('canIUse', 'requestLogin')
        if (canCustomerLogin) {
          this.SodaBridge('customer.requestLogin', {needPopup: 0}).then((info = {}) => {
            let { data = {} } = info
            callback(data.userInfo || data)
          })
        } else if (canLogin) {
          this.SodaBridge('requestLogin', {needPopup: 0}).then((info = {}) => {
            let { data = {} } = info
            callback(data.userInfo || data)
          })
        }
      },
      getDecodeURI (prop, query) {
        return query[prop] && decodeURIComponent(query[prop])
      },
      async handleLoading (obj) {
        this.loading = false
        let timing = window.performance.timing
        this.$nextTick(() => {
          // 渲染完成告诉ios
          this.SodaBridge('customer.finishedLoadHtml', {}).then(function () {})
        })
        // 页面白屏埋点
        // let requestEnd = new Date().getTime()
        let globalParamsData = await this.SodaBridge('getGlobalParams', 'badcase')
        const globalParams = globalParamsData.data
        if (!PerformanceTool.isReported) {
          setTimeout(() => {
            trackEvent({
              eventId: 'sailing_act_x_page_home_load_timing',
              eventLabel: '券和活动的弹窗',
              attrs: {
                ...PerformanceTool.getPerformanceCommonParams(),
                window_type: this.type,
                router: this.$route.fullPath,
                pageEnterTiming: timing.navigationStart,
                networkType: globalParams.networkType
              }
            })
            this.trackPerformanceEntry()
          })
        }
      },
      async dispatchPopDialog () {
        const globalParamsData = await this.SodaBridge('getGlobalParams', 'badcase')
        const globalParams = globalParamsData.data
        let params = {
          position: 1,
          fromH5: true, // 为了区分端接口请求
          ...globalParams
        }
        const promoCode = this.getDecodeURI('promoCode', this.$route.query)
        if (promoCode) {
          params['promoCode'] = promoCode
        }
        if (this.isIOS) {
          params['dataType'] = IOS_DATA_TYPE
        }
        let requestStart = new Date().getTime()
        try {
          const res = await Api.getPopDialog(params)
          const info = res.data
          if (info.errno === 0) {
            if (info.data && info.data.constructor !== Array && info.data.needPopup) {
              this.popupUrl = info.data.popupUrl
              const query = this.getQuery(this.popupUrl)
              this.initQuery(query)
              this.loginShow = true
            } else {
              this.handleHide()
            }
          }
          this.trackApi(requestStart, info)
        } catch (e) {
          this.trackApi(requestStart, e)
          let errorToast = this.$createToast({
            txt: this.gettext('网络繁忙，请稍后再试'),
            time: 2000,
            mask: false,
            type: 'error'
          })
          errorToast.show()
          window.setTimeout(() => this.handleHide(), 2000)
        }
      },
      getQuery (str) {
        if (!str) {
          return ''
        }
        let paramsString = str.split('?')[1]
        var items = paramsString.split('&')
        var result = {}
        items.forEach(item => {
          let temp = item.split('=')
          result[temp[0]] = temp[1]
        })
        return result
      },
      // 券和运营活动的弹窗
      trackMounted (options) {
        trackEvent({
          eventId: 'sailing_c_x_window_common_sw',
          eventLabel: '券和活动的弹窗',
          attrs: {...options}
        })
      },
      // api请求时间埋点
      trackApi (requestStart, responseData) {
        let requestEnd = new Date().getTime()
        this.apiRequestTime = requestEnd - requestStart
        trackEvent({
          eventId: 'sailing_act_x_api_request_timing',
          eventLabel: '券和活动的弹窗',
          attrs: {
            window_type: this.type,
            router: this.$route.fullPath,
            pageEnterTiming: window.performance.timing.navigationStart,
            ApiRequestStartTiming: requestStart,
            ApiRequestEndTiming: requestEnd,
            ApiRequestiming: requestEnd - requestStart,
            firstPageTiming: requestEnd - window.performance.timing.navigationStart,
            responseData: responseData
          }
        })
      },
      // 所有资源时间埋点
      trackPerformanceEntry () {
        trackEvent({
          eventId: 'sailing_act_x_static_resource_load_timing',
          eventLabel: '券和活动的弹窗',
          attrs: {
            ...PerformanceTool.getStaticResourceDownloadParams()
          }
        })
      }
    }
  }
</script>
<style lang="scss" scoped>
.fullpage {
  height: 100%;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  background-color: rgba(0, 0, 0, 0);
  img {
    width: 100%
  }
  .mask {
    z-index: 9
  }
}
</style>